import { useEffect, useState } from 'react';
import type { Pagina } from '@kodica/shared';

import {
  Cargando,
  Celda,
  Chip,
  Encabezado,
  ErrorCaja,
  Fila,
  Paginador,
  Panel,
  Tabla,
  Vacio,
} from '../componentes/ui';
import { consulta, useRecurso } from '../lib/consultas';

interface Lectura {
  id: string;
  codigoLeido: string;
  rssi: number | null;
  aceptada: boolean;
  motivoRechazo: string | null;
  leidoEn: string;
  dispositivo: { nombre: string };
  carril: { nombre: string } | null;
  tag: { unidad: { clave: string } } | null;
}

/** La reja es un flujo en vivo; se refresca solo para que el guardia vea al
 * instante por qué a alguien no le abrió. */
const REFRESCO_MS = 5000;

function hora(iso: string): string {
  return new Date(iso).toLocaleString('es-MX', {
    day: '2-digit',
    month: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  });
}

export function LecturasPagina() {
  const [pagina, setPagina] = useState(1);
  const ruta = consulta('/uhf/lecturas', { pagina, porPagina: 25 });
  const { datos, cargando, error, recargar } = useRecurso<Pagina<Lectura>>(ruta);

  useEffect(() => {
    const id = setInterval(recargar, REFRESCO_MS);
    return () => clearInterval(id);
  }, [recargar]);

  return (
    <>
      <Encabezado
        titulo="Lecturas de tag"
        descripcion="Lo que se presenta en el carril de condóminos, en vivo"
      />

      <Panel>
        {error && <ErrorCaja>{error}</ErrorCaja>}
        {/* Solo al cargar la primera vez; en los refrescos se conserva la tabla. */}
        {cargando && !datos && <Cargando />}
        {!error && datos && datos.total === 0 && <Vacio>Todavía no hay lecturas.</Vacio>}

        {!error && datos && datos.total > 0 && (
          <>
            <Tabla cabeceras={['Hora', 'Código', 'Unidad', 'Carril', 'Resultado']}>
              {datos.datos.map((l) => (
                <Fila key={l.id}>
                  <Celda>{hora(l.leidoEn)}</Celda>
                  <Celda mono fuerte>
                    {l.codigoLeido}
                  </Celda>
                  <Celda fuerte>{l.tag?.unidad.clave ?? '—'}</Celda>
                  <Celda>{l.carril?.nombre ?? '—'}</Celda>
                  <Celda>
                    {l.aceptada ? (
                      <Chip tono="ok">Abrió</Chip>
                    ) : (
                      <Chip tono="malo">{l.motivoRechazo ?? 'Rechazado'}</Chip>
                    )}
                  </Celda>
                </Fila>
              ))}
            </Tabla>
            <Paginador
              pagina={datos.pagina}
              paginas={datos.paginas}
              total={datos.total}
              alCambiar={setPagina}
            />
          </>
        )}
      </Panel>
    </>
  );
}
